<template>
  <b-container fluid>
    <b-row>
      <b-col cols="10" offset="1">
      <h3>{{ $t('LNG_STUDENT_MANAGEMENT_TITLE', this.lang) }}</h3>
      </b-col>
    </b-row>
    <b-row>
    
      <b-col cols="10" offset="1">
          <b-alert :show="dismissCountDown"
                  variant="success"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           {{this.successMessage}}
          </b-alert>
          <v-client-table ref="studentsTable" :data="studentsData" :columns="studentsColumns" :options="studentsOptions">
             <div slot="editStudent" slot-scope="props" class="fa fa-edit" v-on:click="studentRowClick(props)" style="cursor: pointer;"></div>
          </v-client-table>
      </b-col>
    </b-row>
         
    <b-modal v-model="editStudent" effect="fade" @shown="setModalInputFocus" :title="this.editBoxTitle" >
      <b-alert variant="danger" :show="showMissingData">    
          {{ $t('LNG_STUDENT_MISSING_DATA', this.lang) }}
      </b-alert>
      <b-alert variant="danger" :show="showErrorMessage">    
          {{ this.errorMessage }}
      </b-alert>
      <b-input ref="studentFirstname" v-model="studentFirstname" type="text" required :placeholder="$t('LNG_STUDENT_FIRSTNAME', this.lang)" class="mb-3"/>
      <b-input ref="studentName" v-model="studentName" type="text" required :placeholder="$t('LNG_STUDENT_NAME', this.lang)" class="mb-3"/>
      <b-form-select v-model="selectSexe.value" :options="selectSexe.options" class="mb-3" size="sm" />
      <b-form-select v-model="selectEntity.value" :options="selectEntity.options" class="mb-3" size="sm" />
      <b-form-select multiple :select-size="4" v-model="selectGroup.value" :options="selectGroup.options" class="mb-3" />
      <div slot="modal-footer">
        <b-button type="button" v-on:click.prevent="exitEditStudent()">{{ $t('LNG_CLOSE', lang) }}</b-button>
        <b-button variant="evaobj" type="button" v-on:click.prevent="saveEditStudent($event)">{{ this.btnSaveStudent }}</b-button>
      </div>
     </b-modal>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
// const constDateFormat = 'DD.MM.YYYY'
export default {
  name: 'managementStudentsGroups',
  components: {
  },
  data () {
    return {
      editStudent: false, // Utilisé pour savoir si l'on est en mode édition d'un élève
      showMissingData: false, // Utilisé pour indiquer à l'utilisateur qu'il manque des données
      showErrorMessage: false, // Utilisé pour indiquer que l'élève n'a pas pu être sauvé
      errorMessage: '', // Utilisé pour contenir le texte du message d'erreur lors de l'ajout ou l'édition d'un élève
      studentName: '', // Utilisé pour stocker le nom de l'élève
      studentFirstname: '', // Utilisé pour stocker le prénom de l'élève
      selectGroup: {  // Utilisé pour stocker les groupes auxquels appartient l'élève
        options: [],
        value: []
      },
      selectEntity: { // Utilisé pour stocker l'entité auquel appartient l'élève
        options: [],
        value: null
      },
      selectedStudent: '', // Utilisé pour stocker l'id du participant sélectionné
      studentsData: [], // Contient la liste des étudiants affichés dans la table
      studentsColumns: ['name', 'firstname', 'entity', 'groups', 'editStudent'], // Liste des colonnes affichées dans la table
      studentsOptions: { // Propriétés de la table
        headings: {
          name: this.$t('LNG_NAME_TEACHER', this.lang),
          firstname: this.$t('LNG_FIRSTNAME', this.lang),
          entity: this.$t('LNG_ENTITY', this.lang),
          groups: this.$t('LNG_GROUPS', this.lang),
          editStudent: this.$t('LNG_EDIT', this.lang)
        },
        filterByColumn: true,
        perPage: 1000,
        perPageValues: [10, 25, 50, 100, 250, 500, 1000],
        texts: this.$parent.tableTexts,
        sortIcon: { base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down', is: 'glyphicon-sort' },
        filterable: ['name', 'firstname', 'groups', 'entity'],
        sortable: ['name', 'firstname', 'groups', 'disabled', 'entity']
      },
      editBoxTitle: this.$t('LNG_EDIT_STUDENT', this.lang), // Contient le texte affiché dans le titre de la boite permettant d'ajouter/éditer un élève
      btnSaveStudent: this.$t('LNG_SAVE', this.lang), // Texte du bouton qui qui permet d'ajouter /éditer un élève
      selectSexe: {  // Utilisé pour stocker le genre de l'élève
        options: [{value: null, text: this.$t('LNG_SELECT_SEXE_DEFAULT', this.lang)}, {text: this.$t('LNG_MALE', this.lang), value: '0'}, {text: this.$t('LNG_FEMALE', this.lang), value: '1'}],
        value: null
      },
      showSuccessMessage: false,
      successMessage: '',
      selectedStudentOriginalGroups: [], // Stocke la liste des groupes originaux de l'élève avant l'édition
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  mounted: function () {
    moment.locale('fr-ch')
    this.loadStudents()
    this.loadMyGroups()
  },
  computed: {
    ...mapState([
      'api',
      'fullname',
      'lang'
    ])
  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    addStudent () {
      this.editBoxTitle = this.$t('LNG_ADD_NEW_STUDENT', this.lang)
      this.btnSaveStudent = this.$t('LNG_ADD', this.lang)
      this.editStudent = !this.editStudent
      this.showErrorMessage = false
      this.showMissingData = false
    },
    exitEditStudent () {
      this.resetForm()
      this.editStudent = false
    },
    resetForm () {
      this.studentName = ''
      this.studentFirstname = ''
      this.selectGroup.value = []
      this.selectSexe.value = null
      this.selectEntity.value = null
      this.selectedStudent = ''
      this.selectedStudentOriginalGroups = []
      this.showErrorMessage = false
      this.showMissingData = false
    },
    saveEditStudent (event) {
      this.showErrorMessage = false
      this.showSuccessMessage = false
      if (this.selectedStudent === '') {
        this.successMessage = this.$t('LNG_NEW_STUDENT_ADDED', this.lang)
        this.errorMessage = this.$t('LNG_NEW_STUDENT_NOT_ADDED', this.lang)
      } else {
        this.successMessage = this.$t('LNG_STUDENT_UPDATED', this.lang)
        this.errorMessage = this.$t('LNG_STUDENT_NOT_UPDATED', this.lang)
      }
      // Vérifier si les données minimales sont renseignées
      if (this.studentName === '' || this.studentFirstname === '' || this.selectSexe.value === null || this.selectEntity.value === null || this.selectGroup.value.length === 0) {
        this.showMissingData = true
        return
      }
      this.showMissingData = false
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'addStudent',
          name: this.studentName,
          firstname: this.studentFirstname,
          groups: this.selectGroup.value,
          entity: this.selectEntity.value,
          id: this.selectedStudent,
          sexe: this.selectSexe.value,
          originalGroups: this.selectedStudentOriginalGroups
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          this.showSuccessMessage = true
          this.resetForm()
          this.editStudent = false
          this.dismissCountDown = this.dismissSecs
          this.loadStudents()
        } else {
          this.showErrorMessage = true
        }
      })
    },
    setModalInputFocus (event) {
      this.$refs.studentFirstname.focus()
    },
    loadStudents () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadMyStudents'
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.studentsData = response.data.students
      })
    },
    loadMyGroups () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadMyGroups'
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        response.data.groups.forEach((e) => {
          this.selectGroup.options.push({text: e.name, value: e.id})
        })
        this.selectEntity.options.push({text: this.$t('LNG_SELECT_ENTITY_DEFAULT', this.lang), value: null})
        response.data.entities.forEach((e) => {
          this.selectEntity.options.push({text: e.name, value: e.id})
        })
      })
    },
    back: function () {
      this.$router.push({ path: '/' })
    },
    studentRowClick: function (row) {
      this.editBoxTitle = this.$t('LNG_EDIT_STUDENT', this.lang)
      this.btnSaveStudent = this.$t('LNG_SAVE', this.lang)
      this.selectedStudent = row.row.id
      this.studentName = row.row.name
      this.studentFirstname = row.row.firstname
      this.selectGroup.value = row.row.groupsId
      this.selectEntity.value = row.row.entityId
      this.selectSexe.value = row.row.sexe
      this.editStudent = true
      this.selectedStudentOriginalGroups = row.row.originalGroupsId
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
</style>



// WEBPACK FOOTER //
// managementStudentsGroups.vue?92f85872